// components/Product.js
import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './Product.css';

const Products = () => {
  const { t } = useTranslation();

  const productKeys = [
    {
      id: 'field-service-optimization',
      icon: '🛠️',
      nameKey: 'solutionsDropdown.fieldService',
      descKey: 'solutionsDetails.field-service-optimization.solution',
      featuresKey: 'solutionsDetails.field-service-optimization.features'
    },
    {
      id: 'operational-forecasting',
      icon: '📈',
      nameKey: 'solutionsDropdown.forecasting',
      descKey: 'solutionsDetails.operational-forecasting.solution',
      featuresKey: 'solutionsDetails.operational-forecasting.features'
    },
    {
      id: 'ops-analytics-anomaly-detection',
      icon: '🔍',
      nameKey: 'solutionsDropdown.analytics',
      descKey: 'solutionsDetails.ops-analytics-anomaly-detection.solution',
      featuresKey: 'solutionsDetails.ops-analytics-anomaly-detection.features'
    },
    {
      id: 'knowledge-intelligence',
      icon: '💡',
      nameKey: 'solutionsDropdown.knowledge',
      descKey: 'solutionsDetails.knowledge-intelligence.solution',
      featuresKey: 'solutionsDetails.knowledge-intelligence.features'
    }
  ];

  return (
    <div className="products-container">
      <div className="products-header">
        <h2>{t('solutionsList.title')}</h2>
        <p>{t('solutionsList.subtitle')}</p>
      </div>

      <div className="products-grid">
        {productKeys.map(prod => {
          // Features is expected to be an array of objects
          const features = t(prod.featuresKey, { returnObjects: true });
          
          return (
            <div className="product-card glass-card" key={prod.id}>
              <div className="product-icon">{prod.icon}</div>
              <h3>{t(prod.nameKey)}</h3>
              <p className="product-desc">{t(prod.descKey)}</p>
              
              {Array.isArray(features) && (
                <ul className="product-features">
                  {features.slice(0, 2).map((feat, idx) => (
                    <li key={idx}>
                      <strong>{feat.name}:</strong> {feat.description}
                    </li>
                  ))}
                </ul>
              )}
              
              <Link 
                to={`/solutions/${prod.id}`} 
                className="btn btn-outline" 
                style={{ marginTop: 'auto', textAlign: 'center', display: 'block' }}
                onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              >
                {t('solutionsList.learnMore')}
              </Link>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Products;